var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmotionalStateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.214844,
    y: 0.171875,
    width: 48,
    height: 48,
    rx: 10,
    fill: "#2573EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14356_10089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3946 23.3081H29.7892L19.7405 34.2703L22.4811 26.0487H17L24.3081 16L23.3946 23.3081Z",
    fill: "#F4F8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14356_10089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9244,
    height: 21.9244,
    fill: "white",
    transform: "translate(12.2168 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotionalStateIcon);
export default __webpack_public_path__ + "static/media/emotionalStateIcon.7168bee23ba4b7f0d0a93505d45129b2.svg";
export { ForwardRef as ReactComponent };